module.exports = __webpack_public_path__ + "static/media/Medical-chat-bot.9fa69b2e.png";